import EllipsisContent from "@/Common/Component/EllipsisContent";
import { useTeamContext } from "@/Common/Contex/TeamContext";
import useConfig from "@/hooks/useConfig";
import { Box, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";

const TeamNameRow = ({ teams }: any) => {
  const { setCurrentSelectedTeam, currentSelectedTeam }: any = useTeamContext();
  console.log(currentSelectedTeam);
  const config = useConfig();
  return (
    <Box>
      <Box
        sx={{
          bgcolor:
            currentSelectedTeam?.team_secondary_color || config.secondary,
          width: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <EllipsisContent
          text={(
            currentSelectedTeam?.team_name +
            " " +
            currentSelectedTeam?.team_mascot
          ).toUpperCase()}
          //   maxTextWidth={200}
          sx={{
            fontSize: 72,
            color: currentSelectedTeam?.team_primary_color || config.primary,
            lineHeight: "56px",
            fontStyle: "normal",
            fontWeight: 600,
            px: 3,
            textTransform: "capitalize",
          }}
        />

        <Box sx={{ height: 100, position: "relative" }}>
          <Box
            sx={{
              position: "relative",
              height: 100,
              width: 300,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${
                  JSON.parse(currentSelectedTeam?.overlay_configuration)
                    ?.logo_right || currentSelectedTeam?.team_logo_url
                })`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundPositionY: "-8px",
                height: "100%",
                width: "100%",
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            />
            {/* Gradient overlay for left-to-right opacity effect */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: `linear-gradient(to right, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                } 0%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }CC 20%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }99 40%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }66 60%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }33 80%, ${
                  currentSelectedTeam?.team_secondary_color || config.secondary
                }00 100%)`,
                zIndex: 1,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default TeamNameRow;
